jQuery(document).ready(function ($) {  
  $('.adi_tent_popview,.popup_slider_container_tent .closeicon,.more_pro_img_tent').on('click', function(){
    $('.product_popup_tent').toggleClass("active");
    $(".product_popup_tent").addClass("animation");    
        setTimeout(function() {
           $(".product_popup_tent").removeClass("animation");
       	}, 500);
    $("body").css("overflow","hidden");
  });            
  
  
  const $menu = $('.popup_slider_container_tent');
  
  $(document).mouseup(e => {      	       
    	if($('.product_popup_tent').hasClass('active'))
        {
    		if(!$menu.is(e.target) && $menu.has(e.target).length == 0) 
        	{
              	$("body").css("overflow","");
              	$('.product_popup_tent').toggleClass("active");
    			$('.LeftArrow_tent').remove();
    			$('.RightArrow_tent').remove();
    			$('.tent_popup_image_slider').slick('unslick');
    			$('.tent_popup_image_slider').empty();    
        	} 
        } 
 	});
  
  
  
  const $menu1 = $('.popup_slider_container');
  
  $(document).mouseup(e => {      	       
    	if($('.product_popup').hasClass('active'))
        {
    		if(!$menu1.is(e.target) && $menu1.has(e.target).length == 0) 
        	{
              	$("body").css("overflow","");
        		$(".product_popup").removeClass("active");
              	//$(".popup_fade").fadeOut();
    			
        	} 
        } 
 	});
  
  
  
  
  
  $('.adi_tent_popview').on('click', function(){
    
    
    
    $(this).prev().find('.slick-slide').each(function( index ) {
  		var popu_src = $(this).find('img').attr('src');
      	$('.tent_popup_image_slider').append("<div class='tent_popup_image'><img class='carouselImg' src='" + popu_src + "'/></div>");      
      	if($(this).hasClass('slick-current'))
        {
         window.popupInt = index;          
        }
		});        
    
    	$('.tent_popup_image_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: popupInt,
        dots: true,
        autoplay: false,    
        prevArrow: '<button type="button" class="singleProductLeftArrow_tent"><span class="popArCont"> 	<span class="popAr"> 		<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>   <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>  <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> 	</span>	 	<span class="popArHover"> 		<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> 	</span></span> </button>',
          
        nextArrow: '<button type="button" class="singleProductRightArrow_tent"> <span class="popArCont">	<span class="popAr"> 		<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>    <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>   <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> 	</span>	 	<span class="popArHover"> 		<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> 	</span></span> </button>'             
       });
    
    });
  
  $('.more_pro_img_tent').on('click', function(){        	   
      
    $(this).closest( ".grid__item" ).find('.tent_popview .slick-slide').each(function( index ) {    		
      	var popu_src = $(this).find('img').attr('src');
      	$('.tent_popup_image_slider').append("<div class='tent_popup_image'><img class='carouselImg' src='" + popu_src + "'/></div>"); 
      	if($(this).hasClass('slick-current'))
        {
         window.popupInt = index;          
        }
      	});        
    	
    	$('.tent_popup_image_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: popupInt,
        dots: true,
        autoplay: false,      
          prevArrow: '<button type="button" class="singleProductLeftArrow_tent"> <span class="popArCont">	<span class="popAr"> 		<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>    <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>    <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> 	</span>	 	<span class="popArHover"> 		<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> </span>	</span> </button>',
          
        nextArrow: '<button type="button" class="singleProductRightArrow_tent"> <span class="popArCont">	<span class="popAr"> 		<svg xmlns="http://www.w3.org/2000/svg" width="355" height="360" viewBox="0 0 360 360">  <g>     <rect fill="none" id="canvas_background" height="362" width="357" y="-1" x="-1"/>  </g>  <g>    <circle stroke="null" fill="#f4f4f3" id="svg_1" r="174.600006" cy="177.41833" cx="177.062685" class="st0"/>   <path fill="#4f4f4e" id="svg_5" d="m211.949996,172.46832l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg> 	</span>	 	<span class="popArHover"> 		<svg xmlns="http://www.w3.org/2000/svg" width="360" height="360" viewBox="0 0 360 360">   <g>   <title>background</title>   <rect fill="none" id="canvas_background" height="362" width="362" y="-1" x="-1"/>  </g>  <g>   <title>Layer 1</title>   <circle fill="#e8eaec" id="svg_2" r="174.600006" cy="179.999991" cx="180" class="st3"/>   <path fill="#4f4f4e" id="svg_5" d="m214.449998,175.049995l-55.1,-55.1c-1.3,-1.3 -3,-2 -4.8,-2s-3.5,0.7 -4.8,2l-4.1,4.1c-2.6,2.6 -2.6,6.9 0,9.6l46.3,46.3l-46.4,46.4c-1.3,1.3 -2,3 -2,4.8s0.7,3.5 2,4.8l4.1,4.1c1.3,1.3 3,2 4.8,2s3.5,-0.7 4.8,-2l55.2,-55.2c1.3,-1.3 2,-3 2,-4.8c0,-2 -0.7,-3.7 -2,-5z" class="st4"/>  </g> </svg></span> 	</span> </button>'             
       });
    
    	
    });
  
  $('.popup_slider_container_tent .closeicon').on('click', function(){      
    	$('.LeftArrow_tent').remove();
    	$('.RightArrow_tent').remove();
    	$('.tent_popup_image_slider').slick('unslick');
    	$('.tent_popup_image_slider').empty();  
    	$("body").css("overflow","");
  });
  
  
  $('.hero__image').on('click', function(){
      var heroRd = $(this).find('a').attr('href');
    	window.location = heroRd;
    	
  });
  
  
  var fnCon = $('#shopify-section-1574851833507 .content-block');
  var fnConHt = fnCon.height();
  
  if(fnConHt > 430)
  {
    fnCon.addClass('fnMore');
    fnCon.append('<div class="fesReadMore"><span class="read_more_btn">Læs alt</span></div>');			     
  }
  
  $('.read_more_btn').on('click', function(){
    $(this).text($(this).text() == 'Læs alt' ? 'Læs ingen' : 'Læs alt');
    $(this).hide();
    fnCon.toggleClass('fnLess',1000);
  });
  
  
  
    
    
  var dtCon = $('.productSingleDescription');
  var dtConHt = dtCon.height();          
  
  
  if(dtConHt > 630)
  {
    dtCon.addClass('fnMore');
    dtCon.append('<div class="fesReadMore"><span class="read_more_btn">Læs alt</span></div>');			 
    //$('<div class="fesReadMore"><span class="read_more_btn">Læs alt</span></div>').insertAfter(dtCon);			
    
  }
    
  
  
  $('.read_more_btn').on('click', function(){
    $(this).text($(this).text() == 'Læs alt' ? 'Læs ingen' : 'Læs alt');
    $(this).hide();
    dtCon.toggleClass('fnLess',1000);
  });  
  
  
  
  
});